module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_0.90e57878.png";